import React from 'react';
import { AddButton, Container, RightContent, UnselectText } from './SelectedItemsOptions.styles';
import { Text14Bold } from '../utils/Text/Text.styles';

const SelectedItemsOptions = ({ selectedItems, onBtnClick, onUnselectClick, btnTitle = 'Add' }) => {
  return (
    <Container>
      <Text14Bold>{selectedItems.length} Selected</Text14Bold>
      <RightContent>
        <UnselectText onClick={onUnselectClick}>Unselect</UnselectText>
        <AddButton onClick={onBtnClick}>{btnTitle}</AddButton>
      </RightContent>
    </Container>
  );
};

export default SelectedItemsOptions;
